import React from 'react';
import pb from '../../services/pocketbase';

function ReviewManager({ reviews, onReviewApproved, onReviewDeleted }) {

  const handleApprove = async (reviewId) => {
    try {
      const updatedReview = await pb.collection('reviews').update(reviewId, { is_approved: true });
      onReviewApproved(updatedReview);
    } catch (error) {
      console.error("Erreur lors de l'approbation de l'avis:", error);
      alert("L'approbation a échoué.");
    }
  };

  const handleDelete = async (reviewId) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer cet avis ?")) {
      try {
        await pb.collection('reviews').delete(reviewId);
        onReviewDeleted(reviewId);
      } catch (error) {
        console.error("Erreur lors de la suppression de l'avis:", error);
        alert("La suppression a échoué.");
      }
    }
  };

  return (
    <div className="review-manager">
      <h4>Gestion des Avis</h4>
      <div className="reviews-list">
        {reviews.length > 0 ? reviews.map(review => (
          <div key={review.id} className={`review-card ${review.is_approved ? 'approved' : 'pending'}`}>
            <div className="review-card-header">
                <p><strong>Utilisateur:</strong> {review.expand?.user?.name || 'Inconnu'}</p>
                <p><strong>Note:</strong> {'★'.repeat(review.rating)}{'☆'.repeat(5 - review.rating)}</p>
            </div>
            <div className="review-card-body">
                <p>{review.comment}</p>
            </div>
            <div className="review-card-footer">
                <span>Statut: {review.is_approved ? 'Approuvé' : 'En attente'}</span>
                <div className="review-actions">
                    {!review.is_approved && (
                        <button onClick={() => handleApprove(review.id)} className="approve-btn">Approuver</button>
                    )}
                    <button onClick={() => handleDelete(review.id)} className="delete-btn">Supprimer</button>
                </div>
            </div>
          </div>
        )) : (
          <p>Aucun avis à modérer pour le moment.</p>
        )}
      </div>
    </div>
  );
}

export default ReviewManager;
